const sop = {
  state: {
    sopData: {}
  },
  getters: {
    sopData: state => state.sopData
  },
  mutations: {
    SET_SOP_DATA: (state, sopData) => {
      state.sopData = sopData
    }
  },
  actions: {
    setSopData ({ commit }, sopData) {
      commit('SET_SOP_DATA', sopData)
    }
  }
}

export default sop
